import React from "react";
import styles from "./column-container.module.scss";
import borders from "../../styles/borders.module.scss";
import { Column } from "./column";

enum ColumnContainerModifiers {
    mobile, desktop, gapless, multiline, centered, borderleft, borderright, borderbottom, bordertop, fullWidth, fullHeight
}

interface IColumnContainerProps {
    modifiers?: ColumnContainerModifiers[] | null;
    testId?:string;
}

const ColumnContainer = ({
    modifiers,
    testId,
    children
}: React.PropsWithChildren<IColumnContainerProps>): JSX.Element => {

    let columns: any[] = [];

    React.Children.forEach(children, (child: any) => {
        if (child!==null && child.type === ColumnContainer.Column) {
            columns.push(child);
        }
    });

    let className = styles.columns;

    if (modifiers !== null && modifiers !== undefined) {
        modifiers.forEach((value) => {
            switch (value) {
                case ColumnContainerModifiers.mobile:
                    className += ' ' + styles.is_mobile;
                    break;
                case ColumnContainerModifiers.desktop:
                    className += ' ' + styles.is_desktop;
                    break;
                case ColumnContainerModifiers.gapless:
                    className += ' ' + styles.is_gapless;
                    break;
                case ColumnContainerModifiers.multiline:
                    className += ' ' + styles.is_multiline;
                    break;
                case ColumnContainerModifiers.centered:
                    className += ' ' + styles.is_centered;
                    break;
                case ColumnContainerModifiers.borderleft:
                    className += ' ' + borders.is_bordered_left;
                    break;
                case ColumnContainerModifiers.borderright:
                    className += ' ' + borders.is_bordered_right;
                    break;
                case ColumnContainerModifiers.borderbottom:
                    className += ' ' + borders.is_bordered_bottom;
                    break;
                case ColumnContainerModifiers.bordertop:
                    className += ' ' + borders.is_bordered_top;
                    break;
                case ColumnContainerModifiers.fullWidth:
                    className += ' ' + styles.is_fullwidth;
                    break;
                case ColumnContainerModifiers.fullHeight:
                    className += ' ' + styles.is_fullheight;
                    break;
            }
        });
    }

    return (
        <div data-testid={testId} className={className}>
            {columns.map((value, index) => { return value; })}
        </div>
    );
};

ColumnContainer.Column = Column;

export { ColumnContainerModifiers, ColumnContainer }